import React, { useEffect, useState } from "react";
import { Trans } from "@lingui/macro";
import PropTypes from "prop-types";

import { FORMAT_TYPES } from "widgets/richtext";

import { useForumStore } from "../../common/store/forum.store";
import { CHANNEL_CONST } from "@/common/utils/constant";

import styles from "../../forum/forum.css";

import QuoteIcon from "../../common/icons/Quote.svg";

export function Quote({ setEditorFocus }) {
  const [quotedText, setQuotedText] = useState([]);

  function findAncestor(el, cls) {
    let elementIndex = 0;
    while (!el?.className?.includes?.(cls) && elementIndex < 6) {
      el = el?.parentNode;
      elementIndex += 1;
    }
    return el;
  }
  useEffect(function createQuote() {
    function getSelectedText() {
      let text = "";
      if (typeof window.getSelection != "undefined") {
        text = window.getSelection().toString();
      } else if (
        typeof document.selection != "undefined" &&
        document.selection.type === "Text"
      ) {
        text = document.selection.createRange().text;
      }
      return text;
    }

    function showQuoteTooltip(event) {
      const element = document.getElementById("quoteTooltip");
      const parentNode = window.getSelection().getRangeAt(0)
        ?.startContainer?.parentNode;
      const commentElement = findAncestor(parentNode, "commentEditor");
      const topicElement = findAncestor(parentNode, "topicDetailContent");
      if (
        commentElement?.className?.includes?.("commentEditor") ||
        topicElement?.className?.includes?.("topicDetailContent")
      ) {
        let entityType = CHANNEL_CONST.POST;
        let entityId;
        if (commentElement?.className?.includes?.("commentEditor")) {
          entityType = CHANNEL_CONST.COMMENT;
          entityId = commentElement.id;
        }
        let selectedText = getSelectedText();
        setEditorFocus(false);
        const contents = {
          type: FORMAT_TYPES.BLOCKQUOTE,
          data: {
            EntityId: entityId,
            EntityType: entityType
          },
          nodes: [
            {
              type: "paragraph",
              data: {},
              nodes: [{ type: "text", text: selectedText }]
            }
          ]
        };
        if (selectedText) {
          setQuotedText([contents]);
        }
        if (element) {
          if (selectedText && selectedText !== "\n") {
            element.style.display = "block";
            element.style.position = "fixed";
            element.style.left = `${event.clientX}px`;
            element.style.top = `${event.clientY - 30}px`;
          } else {
            element.style.display = "none";
          }
        }
      } else if (element) element.style.display = "none";
    }

    document.onmouseup = showQuoteTooltip;
    document.onkeyup = showQuoteTooltip;
  }, []);

  function onClickQuotedReply() {
    const element = document.getElementById("quoteTooltip");
    element.style.display = "none";
    useForumStore.getState().setQuotedText({ Content: quotedText });
    useForumStore.getState().setReplyComment({});
    setEditorFocus(true);
  }
  return (
    <div
      id="quoteTooltip"
      className={styles.tooltipQuote}
      onClick={onClickQuotedReply}
    >
      <QuoteIcon />
      <span>
        <Trans>Quote & reply</Trans>
      </span>
    </div>
  );
}

Quote.propTypes = {
  onClickQuote: PropTypes.func,
  entityId: PropTypes.string,
  entityType: PropTypes.string,
  setEditorFocus: PropTypes.func
};
